export default function MoreHorizontalIcon({
  size = 36,
  className = '',
  onClick = (event) => {},
  'data-testid': dataTestId
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
  'data-testid'?: string;
}) {
  return (
    <span className={className} onClick={onClick} data-testid={dataTestId}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 32 32'
        fill='currentColor'
      >
        <path d='M13.3335 15.9997C13.3335 14.5269 14.5274 13.333 16.0002 13.333C17.4729 13.333 18.6668 14.5269 18.6668 15.9997C18.6668 17.4724 17.4729 18.6663 16.0002 18.6663C14.5274 18.6663 13.3335 17.4724 13.3335 15.9997Z' />
        <path d='M22.6665 15.9997C22.6665 14.5269 23.8604 13.333 25.3332 13.333C26.8059 13.333 27.9998 14.5269 27.9998 15.9997C27.9998 17.4724 26.8059 18.6663 25.3332 18.6663C23.8604 18.6663 22.6665 17.4724 22.6665 15.9997Z' />
        <path d='M4 15.9997C4 14.5269 5.19391 13.333 6.66667 13.333C8.13943 13.333 9.33333 14.5269 9.33333 15.9997C9.33333 17.4724 8.13943 18.6663 6.66667 18.6663C5.19391 18.6663 4 17.4724 4 15.9997Z' />
      </svg>
    </span>
  );
}
